import { render } from "./AboutMeContainer.vue?vue&type=template&id=700fe1f2&scoped=true"
const script = {}

import "./AboutMeContainer.vue?vue&type=style&index=0&id=700fe1f2&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700fe1f2"]])

export default __exports__